<script setup lang="ts">
const { t } = useTexts();

useSeo({
  title: t('sponsors.official_sponsor'),
});

const sponsorStore = useAppearanceStore();

const sponsors_list = computed(() => {
  return sponsorStore.appearance.sponsorships;
});
</script>

<template>
  <BaseCommonPages
    hide-version
    :title="$t('sponsors.official_sponsor')"
  >
    <div
      v-for="sponsor in sponsors_list"
      :key="sponsor.id"
      :class="$style.patronagesContainer"
    >
      <h2>{{ sponsor.name }}</h2>

      <a
        :href="sponsor.page_url"
        rel="noopener"
        target="_blank"
      >
        <img
          :alt="sponsor.name"
          class="img-fluid mb-3"
          :src="getUrlForApiImage(sponsor.banner)"
          :title="sponsor.name"
        />
      </a>

      <div v-html="sponsor.text" />
    </div>
  </BaseCommonPages>
</template>

<style module lang="postcss">
.patronagesContainer {
  @apply relative py-6 pb-3;

  h2 {
    @apply text-base text-texts mb-6 font-medium;
  }

  ::v-deep(p) {
    @apply mb-6 text-sm text-texts/70 leading-6;
  }

  &:before {
    content: '';
    @apply w-full h-[1px] bg-texts absolute top-0 left-0 opacity-5;
  }

  &:after {
    content: '';
    @apply w-full h-[1px] bg-texts absolute top-[100%] left-0 opacity-5;
  }
}
</style>
